/**
 * Shared shift validation utilities
 * Used by both Candidates and Managers timesheet functionality
 */

/**
 * Validates that end time is after start time for a shift
 * @returns Array of validation errors
 */
export const validateShiftTimes = () => {
  const errors = [];

  // SKIP VALIDATION FOR NOW -- WE ARE ASSUMING OVERNIGHT SHIFTS IN THIS CASE
  // // Only validate if both start and end times are present
  // if (shift.startTime && shift.endTime) {
  //   const startSeconds = shift.startTime.secondsSinceMidnight;
  //   const endSeconds = shift.endTime.secondsSinceMidnight;

  //   // Check if end time is after start time
  //   if (endSeconds <= startSeconds) {
  //     errors.push({
  //       field: "endTime",
  //       message: "End time must be after start time",
  //     });
  //   }
  // }

  return errors;
};

/**
 * Validates that break end time is after break start time
 * @param breakData - The break to validate
 * @returns Array of validation errors
 */
export const validateBreakTimes = (breakData) => {
  const errors = [];
  const startSeconds = breakData.startTime;
  const endSeconds = breakData.endTime;

  // Check if break end time is after break start time
  if (endSeconds <= startSeconds) {
    errors.push({
      field: "breakEndTime",
      message: "Break end time must be after break start time",
    });
  }
  return errors;
};

/**
 * Validates all breaks in a shift
 * @param breaks - Array of breaks to validate
 * @returns Array of validation errors
 */
export const validateShiftBreaks = (breaks) => {
  const errors = [];
  breaks.forEach((breakData, index) => {
    const breakErrors = validateBreakTimes(breakData);
    // Add break index to field names for clarity
    const indexedErrors = breakErrors.map((error) => ({
      ...error,
      field: `break_${index}_${error.field}`,
    }));
    errors.push(...indexedErrors);
  });
  return errors;
};

/**
 * Comprehensive validation for a shift
 * @param shift - The shift to validate
 * @returns Array of validation errors
 */
export const validateShiftData = (shift) => {
  const errors = [];

  // Validate shift times
  errors.push(...validateShiftTimes(shift));

  // Validate breaks
  errors.push(...validateShiftBreaks(shift.breaks));
  return errors;
};

/**
 * Checks if a shift has any validation errors
 * @param shift - The shift to check
 * @returns True if shift has validation errors, false otherwise
 */
export const hasValidationErrors = (shift) => {
  return validateShiftData(shift).length > 0;
};

/**
 * Gets validation error messages as strings (for backward compatibility)
 * @param shift - The shift to validate
 * @returns Array of error message strings
 */
export const getValidationErrorMessages = (shift) => {
  return validateShiftData(shift).map((error) => error.message);
};
